import React from 'react';
import SystemLabel from '../../../../system/SystemLabel/SystemLabel';
import { Col } from 'reactstrap';


export function DisparityChart(props) {
    const { clientResponses, importedAttendees, size, autoFit= false, template, question, questionName, presentParticipants = [] } = props;
    let importedAttendeesFiltered = Array.from(importedAttendees);
    if (question.personType && question.personType > 0) {
        importedAttendeesFiltered = importedAttendeesFiltered.filter(a => {
            let pTypes = a.personTypes.map(pt => { return pt });
            return !pTypes.includes(question.personType);
        })
    }

    const answered = importedAttendeesFiltered.filter(a => {
        return props.clientResponses.map(c => { return c.clientKey }).includes(a.badgeNo)
    }).length

    const notAnsweredButPresent = presentParticipants.filter(a => {
        return !props.clientResponses.map(c => { return c.clientKey }).includes(a.badgeNo)
    }).length
    const notAnswered = importedAttendeesFiltered.filter(a => {
        return !props.clientResponses.map(c => { return c.clientKey }).includes(a.badgeNo)
    }).length
    if (question.type !== 'Option') return null;
    return (
        <div className="jir-scroll" style={{height:"100%", width:"100%", overflow:"auto"}}>
            <div style={{ width: '100%', padding: '15px 10px', display: 'inline-flex' }}>

                <Col className="text-left " style={{
                  fontSize: autoFit ? undefined : template.title.fontSize,
                  fontFamily: template.title.fontFamily,
                  color: template.title.color,
                }}>
                    <div style={template ? {
                        fontSize: autoFit ? undefined : template.title.fontSize,
                        fontFamily: template.title.fontFamily,
                        color: template.title.color,
                    } : undefined} >
                        {questionName}
                    </div>
                </Col>

            </div>
            <div style={{ width: '100%', padding: '15px 10px', display: 'inline-flex' }}>

                <Col className="col-6 text-left " style={template ? {
                    fontSize: autoFit ? undefined : template.subtitle.fontSize,
                    fontFamily: template.subtitle.fontFamily,
                    color: template.subtitle.color
                } : undefined} >
                    <SystemLabel name="Options" />
                </Col>
                <Col className="text-right " style={template ? {
                    fontSize:autoFit ? undefined : template.subtitle.fontSize,
                    fontFamily: template.subtitle.fontFamily,
                    color: template.subtitle.color
                } : undefined} >
                    <SystemLabel name="Count" />
                </Col>
                <Col className="text-right " style={template ? {
                    fontSize:autoFit ? undefined : template.subtitle.fontSize,
                    fontFamily: template.subtitle.fontFamily,
                    color: template.subtitle.color
                } : undefined} >
                    <SystemLabel name="Precentage" />
                </Col>
                <Col className="text-right " style={template ? {
                    fontSize: autoFit ? undefined :template.subtitle.fontSize,
                    fontFamily: template.subtitle.fontFamily,
                    color: template.subtitle.color
                } : undefined} >
                    <SystemLabel name="Present" />
                </Col>
                <Col className="text-right " style={template ? {
                    fontSize: autoFit ? undefined :template.subtitle.fontSize,
                    fontFamily: template.subtitle.fontFamily,
                    color: template.subtitle.color
                } : undefined} >
                    <SystemLabel name="Entitled" />
                </Col>
                
            </div>

            {question.questionOption.map((qo, i) => {
                return <div key={i} style={{ width: '100%', padding: '15px 10px', display: 'inline-flex' }}>
                    <Col className="col-6 text-left" style={template ? {
                        fontSize: autoFit ? undefined : template.subtitle.fontSize,
                        fontFamily: template.subtitle.fontFamily,
                        color: template.subtitle.color
                    } : undefined} >
                        {qo.questionOptionLanguage.find(
                            ql => ql.languageCode == 'swe'
                        ).label}
                    </Col>
                    <ClientResponseCount
                        importedAttendees={importedAttendeesFiltered}
                        clientResponses={clientResponses}
                        presentParticipants={presentParticipants}
                        autoFit={autoFit}
                        style={template ? {
                            fontSize: autoFit ? undefined : template.subtitle.fontSize,
                            fontFamily: template.subtitle.fontFamily,
                            color: template.subtitle.color
                        } : undefined
                        }
                        questionOption={qo} />
                </div>
            })}
            <hr />
            <div style={{ width: '100%', padding: '15px 10px', display: 'inline-flex' }}>
                <Col className="col-6 text-left" style={template ? {
                    fontSize: autoFit ? undefined : template.subtitle.fontSize,
                    fontFamily: template.subtitle.fontFamily,
                    color: template.subtitle.color
                } : undefined} >
                    <SystemLabel name="Participated" />
                </Col>

                <Col className={autoFit ?"text-center" : "text-right"} style={template ? {
                    fontSize: template.subtitle.fontSize,
                    fontFamily: template.subtitle.fontFamily,
                    color: template.subtitle.color
                } : undefined} >
                    {answered}
                </Col>
                <Col className={autoFit ?"text-center" : "text-right"} style={template ? {
                    fontSize: template.subtitle.fontSize,
                    fontFamily: template.subtitle.fontFamily,
                    color: template.subtitle.color
                } : undefined} >
                    
                </Col>
                <Col className={autoFit ?"text-center" : "text-right"} style={template ? {
                    fontSize:autoFit ? undefined : template.subtitle.fontSize,
                    fontFamily: template.subtitle.fontFamily,
                    color: template.subtitle.color
                } : undefined} >
                    {presentParticipants.length > 0 && answered > 0 ? Math.round((answered / presentParticipants.length) * 100) + '%' : '0%'}
                </Col>
                <Col className={autoFit ?"text-center" : "text-right"} style={template ? {
                    fontSize:autoFit ? undefined : template.subtitle.fontSize,
                    fontFamily: template.subtitle.fontFamily,
                    color: template.subtitle.color
                } : undefined} >
                    {importedAttendeesFiltered.length > 0 && answered > 0 ? Math.round((answered / importedAttendeesFiltered.length) * 100) + '%' : '0%'}
                </Col>

            </div>

            <div style={{ width: '100%', padding: '15px 10px', display: 'inline-flex' }}>
                <Col className="col-6 text-left" style={template ? {
                    fontSize: autoFit ? undefined : template.subtitle.fontSize,
                    fontFamily: template.subtitle.fontFamily,
                    color: template.subtitle.color
                } : undefined} >
                    <SystemLabel name="NoneParticipated" />
                </Col>
                <Col className={autoFit ?"text-center" : "text-right"} style={template ? {
                    fontSize: autoFit ? undefined : template.subtitle.fontSize,
                    fontFamily: template.subtitle.fontFamily,
                    color: template.subtitle.color
                } : undefined} >
                    {notAnswered}
                </Col>
                <Col className={autoFit ?"text-center" : "text-right"} style={template ? {
                    fontSize: template.subtitle.fontSize,
                    fontFamily: template.subtitle.fontFamily,
                    color: template.subtitle.color
                } : undefined} >
                    
                </Col>
                <Col className={autoFit ?"text-center" : "text-right"} style={template ? {
                    fontSize: autoFit ? undefined : template.subtitle.fontSize,
                    fontFamily: template.subtitle.fontFamily,
                    color: template.subtitle.color
                } : undefined} >
                    {presentParticipants.length > 0 && notAnsweredButPresent > 0 ? Math.round((notAnsweredButPresent / presentParticipants.length) * 100) + '%' : ''}
                </Col>
                <Col className={autoFit ?"text-center" : "text-right"} style={template ? {
                    fontSize: autoFit ? undefined : template.subtitle.fontSize,
                    fontFamily: template.subtitle.fontFamily,
                    color: template.subtitle.color
                } : undefined} >
                    {importedAttendeesFiltered.length > 0 && notAnswered > 0 ? Math.round((notAnswered / importedAttendeesFiltered.length) * 100) + '%' : ''}
                </Col>
            </div>
            <div  style={{ width: '100%', padding: '15px 10px' , display: 'inline-flex' }}>
                <Col className="col-6 text-left" style={template ? {
                    fontSize:autoFit ? undefined : template.subtitle.fontSize,
                    fontFamily: template.subtitle.fontFamily,
                    color: template.subtitle.color
                } : undefined} >
                    <SystemLabel name="Participants" />
                </Col>
                <Col className={autoFit ?"text-center" : "text-right"} style={template ? {
                    fontSize: autoFit ? undefined :template.subtitle.fontSize,
                    fontFamily: template.subtitle.fontFamily,
                    color: template.subtitle.color
                } : undefined} >
                    {importedAttendeesFiltered.length}
                </Col>
                <Col className={autoFit ?"text-center" : "text-right"} style={template ? {
                    fontSize: template.subtitle.fontSize,
                    fontFamily: template.subtitle.fontFamily,
                    color: template.subtitle.color
                } : undefined} >
                    
                </Col>
                <Col className={autoFit ?"text-center" : "text-right"} style={template ? {
                    fontSize: autoFit ? undefined :template.subtitle.fontSize,
                    fontFamily: template.subtitle.fontFamily,
                    color: template.subtitle.color
                } : undefined} >
                    {presentParticipants.length}
                </Col>
                <Col className={autoFit ?"text-center" : "text-right"} style={template ? {
                    fontSize: autoFit ? undefined :template.subtitle.fontSize,
                    fontFamily: template.subtitle.fontFamily,
                    color: template.subtitle.color
                } : undefined} >
                </Col>
            </div>
        </div>
    )
}

function ClientResponseCount({ clientResponses, questionOption, style, importedAttendees, presentParticipants, autoFit }) {
    const responses = clientResponses.filter(cr => cr.answer == questionOption.questionOptionId.toString()).length;
    var badgeNoList = [];
    importedAttendees.map(ia => {
        badgeNoList.push(ia.badgeNo);
    })
    const answerPersons = [];
    clientResponses.filter(cr => cr.answer == questionOption.questionOptionId.toString() && badgeNoList.includes(cr.clientKey)).map(cr => {
        if (!answerPersons.includes(cr.clientKey)) {
            answerPersons.push(cr.clientKey);
        }
    });
    

    // {importedAttendees.length > 0 && answered > 0 ? Math.round((answered / importedAttendees.length) * 100) + '%' : '0%'}
    return <React.Fragment>
        <Col className={autoFit ?"text-center" : "text-right"} style={style}>
            {responses}
        </Col>
        <Col className={autoFit ?"text-center" : "text-right"} style={style}>
            {responses > 0 && clientResponses.length > 0 ? Math.round(responses / clientResponses.length * 100) + '%' : '0%'}
        </Col>
        <Col className={autoFit ?"text-center" : "text-right"}>
            {answerPersons.length > 0 && presentParticipants.length > 0 ? Math.round(answerPersons.length / presentParticipants.length * 100) + '%' : '0%'}
        </Col>
        <Col className={autoFit ?"text-center" : "text-right"} style={style}>
            {answerPersons.length > 0 && importedAttendees.length > 0 ? Math.round(answerPersons.length / importedAttendees.length * 100) + '%' : '0%'}
        </Col>
    </React.Fragment>
}
